import { render, staticRenderFns } from "./InventoryManage.vue?vue&type=template&id=73b9189c&"
import script from "./InventoryManage.vue?vue&type=script&lang=js&"
export * from "./InventoryManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports